import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';

export const selectCourseToolMetroSchema: ToolSchema = {
  type: 'function',
  name: 'select_course',
  description: 'Confirm the course the user has chosen. Triggers a visual selection animation on the matching card.',
  parameters: {
    type: 'object',
    properties: {
      courseId: {
        type: 'string',
        description: 'The courseId of the chosen course (from the search results)'
      }
    },
    required: ['courseId'],
    additionalProperties: false
  }
};

export const selectCourseToolMetroImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const courseId = typeof args?.courseId === 'string' ? args.courseId.trim() : '';

    if (!courseId) {
      return { success: false, error: 'courseId is required.' };
    }

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('metro-select-course', {
          detail: { courseId }
        })
      );
    }

    return {
      success: true,
      data: { courseId, status: 'selected' }
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error while selecting course'
    };
  }
};
